/* Product editor contract: videos, overview/specs, then H4 + image + feature text. */
(() => {
  function enhance(root) {
    if (root.dataset.ready) return;
    const source = root.querySelector('[data-story-source]');
    if (!source) return;
    const en = root.dataset.locale !== 'ja';
    const el = (tag, cls, text) => {const n=document.createElement(tag); if(cls)n.className=cls; if(text)n.textContent=text; return n;};
    const content=source.cloneNode(true);
    const videoSource=content.querySelector('[data-story-videos]');
    const featureSource=content.querySelector('[data-story-features]');
    const specSource=content.querySelector('[data-story-specs]');
    const variantSpecSource=content.querySelector('[data-story-variant-specs]');
    if(variantSpecSource)variantSpecSource.remove();
    const videos=[...(videoSource?videoSource.content:content).querySelectorAll('iframe')];
    if(videoSource){content.querySelectorAll('iframe').forEach(frame=>frame.remove());videoSource.remove();}
    if(featureSource)featureSource.remove();
    if(specSource)specSource.remove();
    const features=[];
    [...(featureSource?featureSource.content:content).querySelectorAll('h4')].forEach(h=>{
      const nodes=[]; let next=h.nextElementSibling;
      while(next&&!/^H[1-4]$/.test(next.tagName)){nodes.push(next);next=next.nextElementSibling;}
      const image=nodes.flatMap(n=>[...(n.matches('img,video')?[n]:n.querySelectorAll('video,img'))])[0];
      const paragraphs=nodes.filter(n=>n.textContent.trim()).map(n=>n.textContent.trim());
      if(!image||!paragraphs.length)return;
      if(!featureSource && nodes.some(n=>n.matches('table') || n.querySelector('table,a,button,input')))return;
      features.push({title:h.textContent.replace(/[【】]/g,''),image:image.cloneNode(true),text:paragraphs.join(' ')});
      h.remove();nodes.forEach(n=>n.remove());
    });
    const output=el('div','ug-story-content');
    if(videos.length){
      const section=el('section','ug-story-videos');section.setAttribute('aria-label',en?'Product videos':'製品に関する動画');
      const header=el('div','ug-story-section-head');header.append(el('h2','',en?'Product videos':'製品に関する動画'));section.append(header);
      const grid=el('div','ug-story-video-grid');
      videos.forEach((frame,i)=>{
        const url=new URL(frame.src,location.href);
        const youtube = /(^|\.)youtube(?:-nocookie)?\.com$/.test(url.hostname);
        const id = url.hostname === 'youtu.be' ? url.pathname.slice(1) : youtube ? (url.searchParams.get('v') || url.pathname.match(/^\/(?:embed|shorts)\/([\w-]+)$/)?.[1]) : null;
        const match = id && /^[\w-]+$/.test(id) ? [id,id] : null;
        const card=el('div','ug-story-video');
        const copy=frame.cloneNode(true);
        if(match && !url.pathname.startsWith('/embed/'))copy.src=`https://www.youtube.com/embed/${match[1]}`;
        copy.loading='lazy';
        copy.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        copy.allowFullscreen=true;
        copy.title=frame.title || (en?'Product video ':'製品動画 ')+(i+1);
        card.append(copy);
        grid.append(card);frame.remove();
      });section.append(grid);output.append(section);
    }
    if(features.length){
      const section=el('section','ug-story-features');
      const header=el('div','ug-story-section-head');header.append(el('h2','',en?'Product highlights':'製品の特徴'));
      const controls=el('div','ug-story-controls');
      const rail=el('div','ug-story-feature-rail');rail.tabIndex=0;rail.setAttribute('aria-label',en?'Product highlights':'製品の特徴');
      [-1,1].forEach(direction=>{const button=el('button','ug-story-arrow',direction===1?'→':'←');button.type='button';button.setAttribute('aria-label',direction===1?(en?'Next feature':'次の特徴'):(en?'Previous feature':'前の特徴'));button.addEventListener('click',()=>rail.scrollBy({left:direction*(rail.firstElementChild.getBoundingClientRect().width+24),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));controls.append(button);});
      header.append(controls);section.append(header,rail);
      features.forEach((f,i)=>{
        const row=el('article','ug-story-feature');const visual=el('div','ug-story-visual');
        if(f.image.tagName==='VIDEO'){
          f.image.removeAttribute('style');f.image.muted=true;f.image.defaultMuted=true;
          f.image.loop=true;f.image.playsInline=true;f.image.controls=true;
          f.image.setAttribute('aria-label',f.title);
          f.image.autoplay=!matchMedia('(prefers-reduced-motion: reduce)').matches;
          const shape=()=>{const w=f.image.videoWidth||Number(f.image.getAttribute('width'));const h=f.image.videoHeight||Number(f.image.getAttribute('height'));visual.classList.toggle('ug-story-visual--square',w>0&&h>0&&Math.max(w,h)/Math.min(w,h)<=1.1);};
          shape();f.image.addEventListener('loadedmetadata',shape);
        }else{
        f.image.removeAttribute('style');f.image.loading='lazy';f.image.alt=f.title;
        const url=new URL(f.image.src,location.href);
        if(url.hostname==='cdn.shopify.com'){
          f.image.srcset=[480,800,1200,1600].map(w=>{const u=new URL(url);u.searchParams.set('width',w);return `${u} ${w}w`;}).join(', ');
          f.image.sizes='(max-width: 760px) calc(100vw - 32px), 50vw';url.searchParams.set('width','1200');f.image.src=url.href;
        }
        const setImageShape=()=>{
          const width=f.image.naturalWidth||Number(f.image.getAttribute('width'));
          const height=f.image.naturalHeight||Number(f.image.getAttribute('height'));
          // Treat artwork within 10% of square as square, regardless of resolution.
          const isNearSquare=width>0 && height>0 && Math.max(width,height)/Math.min(width,height)<=1.1;
          visual.classList.toggle('ug-story-visual--square',isNearSquare);
        };
        setImageShape();f.image.addEventListener('load',setImageShape);
        }
        visual.append(f.image);const text=el('div','ug-story-feature-copy');text.append(el('h3','',f.title));
        const sentences=f.text.match(/[^。]+。?|[^.!?]+[.!?]?/g)||[f.text];
        const short=f.text;text.append(el('p','',short));
        row.append(visual,text);rail.append(row);
      });output.append(section);
    }
    content.querySelectorAll('h3').forEach(h=>{if(/^(製品の特徴|Product features|Features)$/i.test(h.textContent.trim()))h.remove();});
    // Shopify rich text serializes editor blank lines as <p></p>.
    // Preserve them as visible line breaks instead of deleting authored spacing.
    content.querySelectorAll('p').forEach(p=>{
      if(!p.textContent.trim() && !p.querySelector('img,video,iframe,svg') && [...p.children].every(child=>child.tagName==='BR')){
        p.classList.add('ug-description-blank-line');
        if(!p.children.length)p.append(document.createElement('br'));
      }
    });
    if(content.textContent.trim() || content.querySelector('img,video') || specSource){
      const section=el('section','ug-story-specs');
      section.append(el('h2','',en?'Product specifications':'製品仕様'));
      const layout=el('div','ug-spec-layout');
      const visual=el('div','ug-spec-image');
      const productImage=root.querySelector('[data-story-product-image]');
      if(productImage)visual.append(productImage.content.cloneNode(true));
      const dimensionImage=root.querySelector('[data-story-dimensions]');
      const variantDimensions=root.querySelector('[data-story-variant-dimensions]');
      let updateDimensionVariant=()=>{};
      const dimensionEntries=new Map();
      if(variantDimensions)[...variantDimensions.content.children].forEach(entry=>dimensionEntries.set(entry.dataset.variantDimensionId,entry));
      const commonDimensionLinks=dimensionImage?[...dimensionImage.content.querySelectorAll('a')]:[];
      const hasDimensions=commonDimensionLinks.length||[...dimensionEntries.values()].some(entry=>entry.querySelector('a'));
      if(hasDimensions){
        const photo=el('div','ug-spec-photo');photo.append(...visual.childNodes);
        const diagram=el('div','ug-dimension-gallery');diagram.hidden=true;
        const stage=el('div','ug-dimension-stage');
        const thumbs=el('div','ug-dimension-thumbnails');thumbs.setAttribute('aria-label',en?'Choose a dimension drawing':'寸法図を選択');
        const caption=el('p','ug-dimension-hint',en?'Select an image to view full size.':'画像をクリックすると拡大できます。');
        diagram.append(stage,thumbs,caption);
        const chooser=el('div','ug-dimension-switch');
        const choices=[el('button','',en?'Product photo':'商品写真'),el('button','',en?'Dimensions':'寸法図')];
        function selectView(index){photo.hidden=index!==0;diagram.hidden=index!==1;choices.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));}
        choices.forEach((button,i)=>{button.type='button';button.addEventListener('click',()=>selectView(i));chooser.append(button);});
        let currentImages=null;
        updateDimensionVariant=(id,showDrawing=false)=>{
          const entry=dimensionEntries.get(String(id));
          const links=entry?[...entry.querySelectorAll('a')]:commonDimensionLinks;
          const signature=links.map(link=>link.href).join('|');
          if(signature===currentImages){if(showDrawing&&links.length)selectView(1);return;}currentImages=signature;
          stage.replaceChildren();thumbs.replaceChildren();
          chooser.hidden=links.length===0;
          if(!links.length){selectView(0);return;}
          const panels=[];const buttons=[];
          function show(index){panels.forEach((panel,i)=>panel.hidden=i!==index);buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));}
          links.forEach((link,i)=>{
            const panel=link.cloneNode(true);const fullImage=panel.querySelector('img');if(fullImage)fullImage.loading='eager';panel.className='ug-dimension-full';panel.setAttribute('aria-label',(en?'Enlarge dimension drawing ':'寸法図を拡大 ')+(i+1));stage.append(panel);panels.push(panel);
            const button=el('button','ug-dimension-thumb');button.type='button';button.setAttribute('aria-label',(en?'Dimension drawing ':'寸法図 ')+(i+1));
            const originalImage=link.querySelector('img');if(originalImage){const preview=el('img');preview.alt='';preview.loading='eager';const url=new URL(originalImage.getAttribute('src'),location.href);url.searchParams.set('width','160');preview.src=url.href;button.append(preview);}
            button.append(el('span','',String(i+1)));button.addEventListener('click',()=>show(i));thumbs.append(button);buttons.push(button);
          });
          thumbs.hidden=links.length<2;show(0);if(showDrawing)selectView(1);
        };
        selectView(0);updateDimensionVariant(variantDimensions?.dataset.selectedVariant);
        visual.append(photo,diagram,chooser);
        const productRoot=root.closest('#main-product')||document.getElementById('main-product');
        if(productRoot)productRoot.addEventListener('change',event=>{if(event.target.matches('[name="id"]'))updateDimensionVariant(event.target.value);},true);
      }

      const right=el('div','ug-spec-information');
      const tabs=el('div','ug-spec-tabs');tabs.setAttribute('role','tablist');tabs.setAttribute('aria-label',en?'Product information':'製品情報');
      const originalTables=[...content.querySelectorAll('table')];
      const tables=specSource?[...specSource.content.querySelectorAll('table')]:originalTables;
      const specs=el('div','ug-spec-table-wrap');
      const populatedVariantSpecs=variantSpecSource?[...variantSpecSource.content.children].filter(entry=>entry.querySelector('tbody tr')):[];
      if(populatedVariantSpecs.length){
        const switcher=el('div','ug-variant-specs');
        const chooser=el('div','ug-variant-spec-tabs');chooser.setAttribute('role','tablist');chooser.setAttribute('aria-label',en?'Specifications by variant':'バリエーション別スペック');
        const groups=[];const byGroup=new Map();const byVariant=new Map();
        populatedVariantSpecs.forEach(entry=>{
          const key=entry.dataset.specGroup;
          if(!byGroup.has(key)){const group={entry,index:groups.length};groups.push(group);byGroup.set(key,group);}
          byVariant.set(entry.dataset.variantSpecId,byGroup.get(key).index);
        });
        chooser.style.setProperty('--ug-spec-columns',String(groups.length===3?3:2));
        const variantUid='ug-variant-spec-'+Math.random().toString(36).slice(2,9);
        const variantButtons=[];const variantPanels=[];
        function chooseVariant(index,variantId=groups[index].entry.dataset.variantSpecId,showDrawing=true){

          variantButtons.forEach((button,i)=>{button.setAttribute('aria-selected',String(index===i));button.tabIndex=index===i?0:-1;variantPanels[i].hidden=index!==i;});
        }
        groups.forEach(({entry},i)=>{
          const button=el('button','ug-variant-spec-tab',entry.dataset.specLabel);button.type='button';button.id=variantUid+'-tab-'+i;button.setAttribute('role','tab');button.setAttribute('aria-controls',variantUid+'-panel-'+i);
          const panel=el('div','ug-variant-spec-panel');panel.id=variantUid+'-panel-'+i;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);panel.tabIndex=0;panel.append(...entry.cloneNode(true).childNodes);
          button.addEventListener('click',()=>{chooseVariant(i);activate(1);});
          button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight')next=(i+1)%groups.length;else if(event.key==='ArrowLeft')next=(i+groups.length-1)%groups.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=groups.length-1;else return;event.preventDefault();chooseVariant(next);activate(1);variantButtons[next].focus();});
          chooser.append(button);variantButtons.push(button);variantPanels.push(panel);
        });
        if(groups.length>1)switcher.append(chooser);
        switcher.append(...variantPanels);specs.append(switcher);
        chooseVariant(byVariant.get(variantSpecSource.dataset.selectedVariant)??0,variantSpecSource.dataset.selectedVariant,false);
        // Read the theme's actual variant selection; browsing specs never changes the cart selection.
        const productRoot=root.closest('#main-product')||document.getElementById('main-product');
        if(productRoot)productRoot.addEventListener('change',event=>{
          if(event.target.matches('[name="id"]')&&byVariant.has(event.target.value))chooseVariant(byVariant.get(event.target.value),event.target.value);
        },true);
      }else tables.forEach(t=>specs.append(t.cloneNode(true)));
      const dimensions=el('dl','ug-spec-dimensions');
      tables.forEach(table=>table.querySelectorAll('tr').forEach(row=>{
        const cells=row.querySelectorAll('td,th');
        if(cells.length>=2&&/高さ|幅|長さ|奥行|設置面積|パッドギャップ|height|width|length|depth|footprint/i.test(cells[0].textContent)){
          const pair=el('div');pair.append(el('dt','',cells[0].textContent.trim()),el('dd','',cells[1].textContent.trim()));dimensions.append(pair);
        }
      }));
      originalTables.forEach(t=>t.remove());
      content.querySelectorAll('h3').forEach(h=>{if(/仕様|スペック|specification|specs/i.test(h.textContent))h.remove();});
      const description=el('div','ug-spec-description');
      const intro=content.querySelector('p');if(intro){description.append(intro.cloneNode(true));intro.remove();}
      if(content.textContent.trim() || content.querySelector('img,video'))description.append(...content.childNodes);
      const entries=[[en?'Description':'商品説明',description]];
      if(tables.length||variantSpecSource)entries.push([en?'Specifications':'スペック',specs]);
      const uid='ug-spec-'+Math.random().toString(36).slice(2,9);
      const panels=[];const buttons=[];
      function activate(index){buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(index===i));button.tabIndex=index===i?0:-1;panels[i].hidden=index!==i;});}
      entries.forEach(([label,body],i)=>{
        const button=el('button','ug-spec-tab',label);button.type='button';button.id=uid+'-tab-'+i;button.setAttribute('role','tab');button.setAttribute('aria-controls',uid+'-panel-'+i);
        const panel=el('div','ug-spec-panel');panel.id=uid+'-panel-'+i;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);panel.tabIndex=0;panel.append(body);
        button.addEventListener('click',()=>activate(i));
        button.addEventListener('keydown',event=>{let next=i;if(event.key==='ArrowRight')next=(i+1)%entries.length;else if(event.key==='ArrowLeft')next=(i+entries.length-1)%entries.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=entries.length-1;else return;event.preventDefault();activate(next);buttons[next].focus();});
        buttons.push(button);panels.push(panel);tabs.append(button);
      });
      activate(location.hash==='#product-specifications'&&entries.length>1?1:0);right.append(tabs,...panels);layout.append(visual,right);section.append(layout);section.id='product-specifications';output.append(section);
    }
    if(!output.childElementCount)return;
    source.hidden=true;source.after(output);root.dataset.ready='true';
    // Start only after cloned template videos are connected and visible.
    const featureVideos=[...output.querySelectorAll('.ug-story-visual video')];
    const startVideo=video=>{
      if(!video.autoplay||document.hidden)return;
      video.muted=true;video.defaultMuted=true;video.playsInline=true;
      video.setAttribute('muted','');video.setAttribute('playsinline','');
      const playback=video.play();
      if(playback)playback.catch(()=>{}); // Keep native controls if the browser blocks autoplay.
    };
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting)startVideo(entry.target);
      }),{threshold:0.1});
      featureVideos.forEach(video=>observer.observe(video));
    }else{featureVideos.forEach(startVideo);}
    const resumeVisible=()=>featureVideos.forEach(video=>{
      const box=video.getBoundingClientRect();
      if(box.bottom>0&&box.top<innerHeight&&box.right>0&&box.left<innerWidth)startVideo(video);
    });
    document.addEventListener('visibilitychange',resumeVisible);
    window.addEventListener('pageshow',resumeVisible);
    output.addEventListener('touchend',resumeVisible,{once:true,passive:true});

    if(location.hash==='#product-specifications')requestAnimationFrame(()=>root.querySelector('.ug-story-specs')?.scrollIntoView({block:'start'}));
  }
  const init=()=>document.querySelectorAll('[data-product-story]').forEach(enhance);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
